import { useEffect } from "react";
import { usePhotos } from "@/hooks/usePhotos";
import { photoUrl } from "@/lib/api";

export const Logo = ({ size = "h-10 w-10 text-lg", className = "" }) => {
  const { first } = usePhotos("logo");
  if (first) {
    return <img decoding="async" data-testid="site-logo" src={photoUrl(first)} alt="Goyal Academy" className={`${size.replace(/\bw-\S+/g, "w-auto")} max-w-[160px] shrink-0 object-contain ${className}`} />;
  }
  return (
    <div data-testid="site-logo" className={`flex ${size} shrink-0 items-center justify-center rounded-full border border-terra/60 bg-forest font-display font-semibold text-terra shadow-[0_0_20px_-6px_rgba(14,90,71,0.6)] ${className}`}>
      S
    </div>
  );
};

export const useFavicon = () => {
  const { first } = usePhotos("logo");
  useEffect(() => {
    if (!first) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = photoUrl(first);
  }, [first]);
};
